/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RequestCreateRemarksTemplateRequest,
  RequestDeleteRemarksTemplateRequest,
  RequestGetRemarksTemplateRequest,
  RequestUpdateRemarksTemplateRequest,
  ResponseGetRemarksTemplateResponse,
} from '../models/index';
import {
    RequestCreateRemarksTemplateRequestFromJSON,
    RequestCreateRemarksTemplateRequestToJSON,
    RequestDeleteRemarksTemplateRequestFromJSON,
    RequestDeleteRemarksTemplateRequestToJSON,
    RequestGetRemarksTemplateRequestFromJSON,
    RequestGetRemarksTemplateRequestToJSON,
    RequestUpdateRemarksTemplateRequestFromJSON,
    RequestUpdateRemarksTemplateRequestToJSON,
    ResponseGetRemarksTemplateResponseFromJSON,
    ResponseGetRemarksTemplateResponseToJSON,
} from '../models/index';

export interface RemarksTemplateCreateRemarksTemplatePostRequest {
    req: RequestCreateRemarksTemplateRequest;
}

export interface RemarksTemplateDeleteRemarksTemplatePostRequest {
    req: RequestDeleteRemarksTemplateRequest;
}

export interface RemarksTemplateGetAllRemarksTemplatePostRequest {
    req: RequestGetRemarksTemplateRequest;
}

export interface RemarksTemplateUpdateRemarksTemplatePostRequest {
    req: RequestUpdateRemarksTemplateRequest;
}

/**
 * 
 */
export class RemarksTemplateApi extends runtime.BaseAPI {

    /**
     * 備考新規登録
     * 備考新規登録
     */
    async remarksTemplateCreateRemarksTemplatePostRaw(requestParameters: RemarksTemplateCreateRemarksTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetRemarksTemplateResponse>>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling remarksTemplateCreateRemarksTemplatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/remarksTemplate/createRemarksTemplate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestCreateRemarksTemplateRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetRemarksTemplateResponseFromJSON));
    }

    /**
     * 備考新規登録
     * 備考新規登録
     */
    async remarksTemplateCreateRemarksTemplatePost(requestParameters: RemarksTemplateCreateRemarksTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetRemarksTemplateResponse>> {
        const response = await this.remarksTemplateCreateRemarksTemplatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 備考を削除
     * 備考を削除
     */
    async remarksTemplateDeleteRemarksTemplatePostRaw(requestParameters: RemarksTemplateDeleteRemarksTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetRemarksTemplateResponse>>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling remarksTemplateDeleteRemarksTemplatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/remarksTemplate/deleteRemarksTemplate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestDeleteRemarksTemplateRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetRemarksTemplateResponseFromJSON));
    }

    /**
     * 備考を削除
     * 備考を削除
     */
    async remarksTemplateDeleteRemarksTemplatePost(requestParameters: RemarksTemplateDeleteRemarksTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetRemarksTemplateResponse>> {
        const response = await this.remarksTemplateDeleteRemarksTemplatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 備考一覧を取得
     * 備考一覧を取得
     */
    async remarksTemplateGetAllRemarksTemplatePostRaw(requestParameters: RemarksTemplateGetAllRemarksTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetRemarksTemplateResponse>>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling remarksTemplateGetAllRemarksTemplatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/remarksTemplate/getAllRemarksTemplate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetRemarksTemplateRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetRemarksTemplateResponseFromJSON));
    }

    /**
     * 備考一覧を取得
     * 備考一覧を取得
     */
    async remarksTemplateGetAllRemarksTemplatePost(requestParameters: RemarksTemplateGetAllRemarksTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetRemarksTemplateResponse>> {
        const response = await this.remarksTemplateGetAllRemarksTemplatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 備考更新
     * 備考更新
     */
    async remarksTemplateUpdateRemarksTemplatePostRaw(requestParameters: RemarksTemplateUpdateRemarksTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetRemarksTemplateResponse>>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling remarksTemplateUpdateRemarksTemplatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/remarksTemplate/updateRemarksTemplate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestUpdateRemarksTemplateRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetRemarksTemplateResponseFromJSON));
    }

    /**
     * 備考更新
     * 備考更新
     */
    async remarksTemplateUpdateRemarksTemplatePost(requestParameters: RemarksTemplateUpdateRemarksTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetRemarksTemplateResponse>> {
        const response = await this.remarksTemplateUpdateRemarksTemplatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
